import { type CareSearchInitial } from '@/cam-admin/care-search/CareSearch';
import { makeSceneLookup, type Scene } from '@/designs-dev/scenes';

// Every state the CAM care-search prototype can be in, each paired with the
// `initial` props that drive it there. The single source of truth shared by
// the live state select (CareSearchStage) and the handover spec
// (cam-care-search.tsx) — so the two never drift.
export const careSearchScenes: Scene<CareSearchInitial>[] = [
  {
    id: 'first-visit',
    label: 'First visit',
    kind: 'happy',
    repro: 'No search run, no shortlists',
    initial: { scenario: 'firstVisit' },
  },
  {
    id: 'search-results',
    label: 'Search results',
    kind: 'happy',
    repro: 'Searched, no shortlist yet — empty pane prompts create',
    initial: { scenario: 'searchedNoList' },
  },
  {
    id: 'create',
    label: 'Create shortlist',
    kind: 'happy',
    repro: 'Create-shortlist modal open',
    initial: { scenario: 'searchedNoList', modal: 'create' },
  },
  {
    id: 'draft',
    label: 'Draft shortlist',
    kind: 'happy',
    repro: 'Draft shortlist with statuses and notes on seed providers',
    initial: { scenario: 'draft' },
  },
  {
    id: 'provider-detail',
    label: 'Provider detail',
    kind: 'happy',
    repro: 'Detail overlay for Oakwood, with its global notes',
    initial: { scenario: 'draft', detailProvider: 'Oakwood care home' },
  },
  {
    id: 'notes',
    label: 'Global notes from a result card',
    kind: 'happy',
    repro: '‘Add note to provider’ on a result card',
    initial: { scenario: 'searchedNoList', notes: 'Oakwood care home' },
  },
  {
    id: 'dismiss',
    label: 'Dismiss a provider',
    kind: 'happy',
    repro: 'Dismiss dialog open for Bramble court',
    initial: { scenario: 'draft', dismiss: 'Bramble court' },
  },
  {
    id: 'map-view',
    label: 'Map view',
    kind: 'happy',
    repro: 'Map toggle on search results — mock map, illustrative pins',
    initial: { scenario: 'draft', view: 'map' },
  },
  {
    id: 'publish',
    label: 'Publish',
    kind: 'happy',
    repro: 'Publish confirmation dialog open',
    initial: { scenario: 'draft', publish: 'one' },
  },
  {
    id: 'published',
    label: 'Published shortlist',
    kind: 'happy',
    repro: 'Published shortlist — edits stay live once published',
    initial: { scenario: 'published' },
  },
  {
    id: 'republish',
    label: 'Re-publish',
    kind: 'edge',
    repro: 'Publishing an already-published list notifies the circle again',
    initial: { scenario: 'published', publish: 'one' },
  },
  {
    id: 'secured-elsewhere',
    label: 'Care secured elsewhere',
    kind: 'edge',
    repro:
      'The carer declared it on the member side: banner over the shortlists, publishing off',
    initial: { scenario: 'securedElsewhere' },
  },
  {
    id: 'detail-waitlist',
    label: 'Waitlist provider',
    kind: 'edge',
    repro: 'Cherry Tree house: availability shows Waitlist on card and detail',
    initial: { scenario: 'draft', detailProvider: 'Cherry Tree house' },
  },
  {
    id: 'dismissed',
    label: 'Dismissed providers',
    kind: 'edge',
    repro:
      'Show-dismissed toggle: Hillcrest manor seed, with reason and restore',
    initial: { scenario: 'draft', showDismissed: true },
  },
];

export const careSearchSceneById = makeSceneLookup(careSearchScenes);
